import React, { useState } from "react";
import * as FaIcons from 'react-icons/fa';
import { Form, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import * as AiIcons from 'react-icons/ai';
import * as BsIcons from 'react-icons/bs';
import { NavLink } from "react-router-dom";
import Cookies from "universal-cookie";
import { sha256 } from "js-sha256";


const cookies = new Cookies();

const DoctorLogin = () => {
    const [passwordText, setPasswordText] = useState('')
    const [IdText, setIdText] = useState('')
    const [passwordType, setPasswordType] = useState(false)
    const [erroMsg, setErrorMsg] = useState({
        empty: false,
        wrongInfo: false
    })

    const submitForm = () => {
        if (IdText === 'doctor' && passwordText === '1234') {
            setErrorMsg({
                empty: false,
                wrongInfo: false
            })
            cookies.set('token', sha256(IdText + passwordText), { path: '/' })
            cookies.set('user-type', 1, { path: '/' })

            window.location.href = "/doctor-dashboard"
        } else {
            if (IdText === '' && passwordText === '') {
                setErrorMsg({
                    empty: true,
                    wrongInfo: false
                })
            } else {
                setErrorMsg({
                    empty: false,
                    wrongInfo: true
                })
            }
        }
    }
    if (cookies.get("token") && cookies.get("user-type")) {
        console.log(cookies.get("user-type"))
        switch (cookies.get("user-type")) {
            case '1':
                window.location.href = "/doctor-dashboard";
                break;
            case '2':
                window.location.href = "/syndicate-dashboard";
                break;
            case '3':
                window.location.href = "/moh-dashboard";
                break;
            case '4':
                window.location.href = "/mof-dashboard";
                break;
            default:
                break;
        }
    }
    return (
        <div className="Doctor-div">
            <div className="Doctor-card">
               
                <div className="Doctor-rightCard" style={{ backgroundColor: '#2E5266FF' }}>
                    <div style={{ height: '85%', display: 'flex', flexDirection: 'column', textAlign: 'center', justifyContent: 'center', alignItems: 'center' }}>
                        <FaIcons.FaUserMd size={170} style={{ marginBottom: 30 }} />
                        <h1>مرحباً بكَ</h1>
                        <h6>يرجى تسجيل الدخول <br></br>وفق المعلومات المطلوبة</h6>
                    </div>
                    <h6>لطلب المساعدة</h6>
                    <div style={{ display: 'flex', marginTop: -10, flexDirection: 'column', textAlign: 'center', fontSize: 14 }}>
                        +964123456789  /  +964987654321
                    </div>
                </div>
            
                <div className="Doctor-leftCard">
                    <Form style={{ width: '65%' }} onSubmit={(e) => { e.preventDefault(); submitForm() }}>
                        <Form.Group className="mb-3" controlId="formBasicEmail">
                            <Form.Label>رقم هوية النقابة</Form.Label>
                            <Form.Control onChange={(e) => setIdText(e.target.value)} style={{ display: 'flex', textAlign: 'right', alignItems: 'center' }} type="text" placeholder="(ABC-123456789) مثال" />
                            <Form.Text className="text-muted" style={{ fontSize: 12 }}>
                                تنويه : نحن لا نقوم بمشاركة المعلومات مع اي شخص آخر
                            </Form.Text>
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>كلمة المرور</Form.Label>
                            <Form.Control onChange={(e) => setPasswordText(e.target.value)} type={passwordType ? 'text' : 'password'} style={{ display: 'flex', textAlign: 'right', alignItems: 'center' }} placeholder="************" />
                            <div style={{  height: 20, display: 'flex', marginTop: -30, marginLeft: 10, justifyContent: 'flex-end', alignItems: 'center', }} onClick={() => setPasswordType(!passwordType)}>
                                {passwordType ?
                                    <AiIcons.AiFillEye size={20} style={{ cursor: 'pointer' }} />
                                    :
                                    <AiIcons.AiFillEyeInvisible size={20} style={{ cursor: 'pointer' }} />
                                }
                            </div>
                        </Form.Group>
                        <Form.Group className="mb-3" style={{ display: 'flex', fontSize: 16, justifyContent: 'flex-start', alignItems: 'center' }} controlId="formBasicCheckbox">
                            <Form.Check type="checkbox" label="تذكرني" />
                        </Form.Group>
                        <Button variant="primary" style={{ width: '100%', backgroundColor: '#2E5266FF', borderColor: '#2E5266FF' }} type='submit'>
                            تسجيل الدخول
                        </Button>
                        {erroMsg ?
                            erroMsg.empty ?
                                <div style={{ color: 'red', fontSize: 14, marginTop: 10 }}>! يرجى ملئ الحقول اولاً</div>
                                :
                                erroMsg.wrongInfo ?
                                    <div style={{ color: 'red', fontSize: 14, marginTop: 10 }}>! هنالك خطأ في المعلومات المدخلة</div>
                                    : null
                            :
                            null
                        }
                    </Form>
                </div>
                <NavLink
                    className="back-btn"
                    to='/'
                    exact="true"
                >
                    <BsIcons.BsArrowLeft size={40} color='#00000099' />
                </NavLink>
            </div>
        </div>
    )
}


export default DoctorLogin;